/** @format */

import React, { Component } from "react";
import { Accordion, Card } from "react-bootstrap";

import Header from "../components/Header";
import Footer from "../components/Footer";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
} from "../global/browserFunctions";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";

class FAQ extends Component {
	constructor(props) {
		super(props);
		var html = window.FAQ_UPDATE || {};

		this.state = {
			headermenu: true,
			contents: html,
			title_content: [],


		};
		this.Faqupdate = this.Faqupdate.bind(this)
		if (!getCookie("log")) {
			this.GoToPage("/");
		}
	}
	componentDidMount() {
		document.title = "FAQ";
		this.Faqupdate();
	}
	GoToPage(path) {
		this.props.history.push(path);
	}
	Faqupdate() {
		var obj = window.FAQ_UPDATE;
		if (obj !== null && obj != undefined) {
			if (Object.keys(obj).length != 0) {
				this.setState({ title_content: obj["TITLE CONTENT"] })
				delete obj["TITLE CONTENT"];
				var count = 1
				Object.keys(obj).forEach(function (key, value) {
					var array = obj[key]
					array.forEach((e, i) => {
						obj[key][i]['eventkey'] = count
						console.log('val')
						count++
					});

				});
				this.setState({ contents: obj })
				console.log(obj)

			}
			else {
			}
		} else {

		}

	}
	render() {
		return (
			<React.Fragment>
				<Header headermenu={this.headermenu} history={this.props.history} />
				<section className='hero py-6'>
					<Container>
						<Breadcrumb className='pl-0'>
							<BreadcrumbItem>
								<a href='/home'>Home</a>
							</BreadcrumbItem>
							<BreadcrumbItem active>Frequently asked questions</BreadcrumbItem>
						</Breadcrumb>
						<div className={'hero-content ' + this.state.title_content?.length}>
							{this.state.title_content.length != 0 && this.state.title_content.map(item =>
								<div key={item}>
									<h1 className='mb-5 text-center' dangerouslySetInnerHTML={{ __html: item.Question }}></h1>
									<div>
										<p className='lead text-muted mb-0' dangerouslySetInnerHTML={{ __html: item.Answer }}>

										</p>
									</div>
								</div>
							)}
							{/* <h1 className='mb-5 text-center'>F.A.Q.s</h1>
							<div>
								<p className='lead text-muted mb-0'>
									Have questions? We can help! Below, you'll find answers to
									lots of common questions about sizing, purchasing, warranty,
									and so forth. Please look through these before contacting us
									directly. In the event you come up empty-handed, email us at
									customerservice@brooklynbicycleco.com, and we'll do our best
									to get everything sorted. Thanks!
								</p>
							</div> */}
						</div>
					</Container>
				</section>
				<Container>
					{Object.keys(this.state.contents).length != 0 && Object.keys(this.state.contents).map((key, value) =>
						<Accordion className='pb-5 ' key={key}>
							<h2 className='mb-5 text-primary'>{key}</h2>
							{this.state.contents[key].length != 0 && this.state.contents[key].map(item =>
								<Card key={item.Question}>
									<Accordion.Toggle as={Card.Header} eventKey={item.eventkey}>
										<div dangerouslySetInnerHTML={{ __html: item.Question }}></div>

									</Accordion.Toggle>
									<Accordion.Collapse eventKey={item.eventkey}>
										<Card.Body>
											<p dangerouslySetInnerHTML={{ __html: item.Answer }}>

											</p>
										</Card.Body>
									</Accordion.Collapse>
								</Card>
							)}
						</Accordion>
					)}
				</Container>
				{/* <Container>
					<Accordion className='pb-5'>
						<h2 className='mb-5 text-primary'>BILLING & PAYMENTS</h2>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='0'>
								How do I know if I have account credits?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='0'>
								<Card.Body>
									<p>
										If you have outstanding account credits, a monthly statement
										is emailed beginning of every month.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='1'>
								I have outstanding account credits. How will they be applied to
								my invoice?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='1'>
								<Card.Body>
									Any open account credits will be applied to your next invoice.
									Unfortunately, we cannot retroactively apply them to open
									invoices.
								</Card.Body>
							</Accordion.Collapse>
						</Card>

						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='2'>
								When is my payment due?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='2'>
								<Card.Body>
									<p>
										Invoices are charged at the time of shipment. Although we
										keep your payment information on file, we will not charge
										your card, or your Resolve line of credit, until your order
										ships.{" "}
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='3'>
								What forms of payment do you accept?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='3'>
								<Card.Body>
									Credit card and ACH are the most common forms of payment.
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='4'>
								How can I apply for terms?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='4'>
								<Card.Body>
									Terms are available, pending-approval, to our program level
									partners who have a commitment of $4,000 a year or more. To be
									considered for Net60 terms, please email us at{" "}
									<a href='mailto:orders@brooklynbicycleco.com '>
										orders@brooklynbicycleco.com
									</a>{" "}
									expressing your interest, and we will put in a pre-approval
									request with our financing partner. Please note, pre-approvals
									and credit limits are at our partner’s discretion.{" "}
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='5'>
								What is the impact of paying my invoices late?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='5'>
								<Card.Body>
									If you are on terms, you will be subject to a late fees. You
									will also be unable to place orders, or have existing orders
									filled, until the past due amount is paid. Repeated late
									payments may result in the loss of net terms.{" "}
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='6'>
								Do you bill in CAD or USD?{" "}
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='6'>
								<Card.Body>
									We bill our invoices in USD, unless otherwise arranged. For
									Canadian orders billed in USD, we reset the conversion rate at
									the beginning of every month based on the current prevailing
									rate.{" "}
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>

					<Accordion className='pb-5'>
						<h2 className='mb-5 text-primary'>BUY & RIDE PROGRAM</h2>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='0'>
								What is the Buy & Ride program?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='0'>
								<Card.Body>
									<p>
										Our industry-leading Buy & Ride program was the first of its
										kind. We won't every ship a bike to a customer's home.
										Rather, we involve IBDs directly in every bike we sell
										because we thrive on strong IBD relationships and want to
										open customers’ eyes to the benefits of working with a shop.
										It's also been a much better experience for our customers.
										All online orders within reasonable driving distance of a
										stocking dealer are credited to that dealer’s account—a perk
										our dealers love.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='1'>
								Will I lose out if a customer places their order online versus
								through me? How do I benefit?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='1'>
								<Card.Body>
									<p>
										We don’t compete with our dealers, ever. If a customer
										orders a bike online through our website, we will credit you
										for the sale in the form of an account credit, much the same
										as if they purchased the bike directly from you. In fact,
										many of our dealers will direct customers to our site when
										the customer wishes to purchase a bike they don’t have in
										stock.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>
					<Accordion className='pb-5'>
						<h2 className='mb-5 text-primary'>FREIGHT</h2>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='0'>
								How is freight calculated?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='0'>
								<Card.Body>
									<p>
										We prioritize orders that are 12+ bikes to give you the best
										freight incentive and to avoid damage from transit by
										palletizing your shipment.
									</p>
									<p>
										The below chart outlines our current freight costs, but
										costs are subject to change.
									</p>
									<p>
										<table className='table table-bordered'>
											<thead>
												<tr>
													<th scope='col'>Quantity</th>
													<th scope='col'>Freight Cost in USD</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>1-5 Bikes</td>
													<td>$35/bike</td>
												</tr>
												<tr>
													<td>6-8 Bikes</td>
													<td>$27.50/bike</td>
												</tr>
												<tr>
													<td>9-11 Bikes</td>
													<td>$20/bike</td>
												</tr>
												<tr>
													<td>12+ Bikes</td>
													<td>$10/bike</td>
												</tr>
											</tbody>
										</table>
									</p>
									<p>
										<table className='table table-bordered'>
											<thead>
												<tr>
													<th scope='col'>Quantity</th>
													<th scope='col'>Freight Cost in CAD</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>1-5 Bikes</td>
													<td>$45/bike</td>
												</tr>
												<tr>
													<td>6-8 Bikes</td>
													<td>$35/bike</td>
												</tr>
												<tr>
													<td>9-11 Bikes</td>
													<td>$25/bike</td>
												</tr>
												<tr>
													<td>12+ Bikes</td>
													<td>$20/bike</td>
												</tr>
											</tbody>
										</table>
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='1'>
								Is freight more expensive coming from a warehouse not near me?{" "}
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='1'>
								<Card.Body>
									{" "}
									<p>
										We do not calculate freight based upon the shipping distance
										from you, however we do calculate freight based upon the
										total number of bikes shipping from a particular location.
									</p>
									<ul>
										<li>
											Example: If you had seven bikes on order, and six are
											shipping from Warehouse A, and one is shipping from
											Warehouse B, you will be billed at $27.50/bike for six,
											and $35 for one.
										</li>
										<li>
											Example: If you had 24 bikes on order, and 12 are shipping
											from Warehouse A and 12 are shipping from Warehouse B, you
											will be billed at $120 for each shipment.
										</li>
									</ul>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>

					<Accordion className='pb-5'>
						<h2 className='mb-5 text-primary'>ACCOUNT INFORMATION</h2>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='0'>
								How do I update my contact info/shop address/payment
								information/etc.?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='0'>
								<Card.Body>
									<ul>
										<li>Simply log into your account and edit your profile.</li>
										<li>
											Alternatively, you may email us at{" "}
											<a href='mailto:orders@brooklynbicycleco.com'>
												orders@brooklynbicycleco.com
											</a>
											, or give us a call at 800.631.0630 and we will be happy
											to update your information.
										</li>
									</ul>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>

					<Accordion className='pb-5'>
						<h2 className='mb-5 text-primary'>ORDER MANAGEMENT</h2>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='0'>
								My order says “pending”. What does that mean?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='0'>
								<Card.Body>
									<p>
										Orders in the “pending” or “pending fulfillment” stage are
										undergoing review by our Operations team. Rest assured we
										will update you as soon as your order has been confirmed by
										our team and again when your order has shipped.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='1'>
								What bikes do I have on order, including preseason bikes?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='1'>
								<Card.Body>
									<p>
										For a list of open bikes on order, as well as estimated
										restock dates, please feel free to email us at{" "}
										<a href='mailto:orders@brooklynbicycleco.com'>
											orders@brooklynbicycleco.com
										</a>{" "}
										and we will be glad to assist.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='2'>
								How can I place a backorder for bikes not currently available?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='2'>
								<Card.Body>
									<p>
										If you’re interested in models that aren’t currently see
										available, please email your order for review to{" "}
										<a href='mailto:orders@brooklynbicycleco.com'>
											orders@brooklynbicycleco.com
										</a>{" "}
										Our Operations team will review your order and share
										proposed availability.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>

					<Accordion className='pb-5'>
						<h2 className='mb-5 text-primary'>DAMAGES/SHIPPING ISSUES</h2>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='0'>
								I have an issue with an order, who do I contact?{" "}
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='0'>
								<Card.Body>
									<p>
										Please contact our team at{" "}
										<a href='mailto:orders@brooklynbicycleco.com'>
											orders@brooklynbicycleco.com
										</a>{" "}
										with your order number and a description of your issue, so
										that our team may assist you and work toward a resolution.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='1'>
								I have a warranty issue, what do I do?{" "}
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='1'>
								<Card.Body>
									<p>
										Please email us at{" "}
										<a href='mailto:warranty@brooklynbicycleco.com'>
											warranty@brooklynbicycleco.com
										</a>{" "}
										with the following information.
										<ul>
											<li>Serial number</li>
											<li>Bicycle model</li>
											<li>Bicycle color</li>
											<li>Bicycle size</li>
											<li>Photos/videos of the issue</li>
											<li>Description of the issue</li>
											<li>
												Customer name & date of purchase (if on behalf of a
												customer)
											</li>
										</ul>
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='2'>
								A Buy & Ride came damaged, what do I do?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='2'>
								<Card.Body>
									<ul>
										<li>
											Please <b>STOP</b> the build until you hear back from us.
											We make every effort to remedy the issues BEFORE ever
											notifying the customer.
										</li>
										<li>
											Please email us at{" "}
											<a href='mailto:warranty@brooklynbicycleco.com'>
												warranty@brooklynbicycleco.com
											</a>{" "}
											with the following information.
											<ul>
												<li>Serial number</li>
												<li>Bicycle model</li>
												<li>Bicycle color</li>
												<li>Bicycle size</li>
												<li>Photos/videos of the issue</li>
											</ul>
										</li>
										<li>
											We will do our absolute best to remedy the issue and
											notify the customer, and will update you on how to
											proceed.
										</li>
									</ul>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>

					<Accordion className='pb-5'>
						<h2 className='mb-5 text-primary'>ADDITIONAL QUESTIONS</h2>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='0'>
								Can I buy your wheels?
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='0'>
								<Card.Body>
									<p>
										Due to strict limitations in our contracts with our
										suppliers, we are unable to resell wheels.
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
						<Card>
							<Accordion.Toggle as={Card.Header} eventKey='1'>
								Can I buy a third-party accessory like a basket or helmet?{" "}
							</Accordion.Toggle>

							<Accordion.Collapse eventKey='1'>
								<Card.Body>
									<p>
										Only our Brooklyn Bicycle Co. manufactured accessories (rear
										carriers, light sets, rear crates, front racks) are
										available for purchase. For other accessories, we have
										existing relationships with suppliers like QBP, Highway 2,
										Nantucket, etc. and we’d be happy to connect you with them
										for accessory availability.{" "}
									</p>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>
				</Container> */}
				<Footer />
			</React.Fragment>
		);
	}
}

export default FAQ;
